import ServiceBase from "@app/shared/serviceBase";

export interface NJDOBISubmissionSchedule {
  endDate: string;
  label: string;
  startDate: string;
  submissionScheduleId: number;
  uploadsEnabled: boolean;
}

export default class NjdobiAdminService extends ServiceBase {
  public async getSubmissionSchedules(): Promise<NJDOBISubmissionSchedule[]> {
    return this.makeGet<NJDOBISubmissionSchedule[]>("njdobi/submission-schedules");
  }

  public async updateSubmissionScheduleEndDate(scheduleId: number, endDate: string): Promise<void> {
    await this.makePut(`njdobi/submission-schedules/${scheduleId}/end-date`, endDate);
  }

  public async uploadFacilityTemplate(file: File): Promise<void> {
    const formData = new FormData();
    formData.append("facilityFile", file, file.name);
    await this.makePost("njdobi/templates/facility", formData, undefined, true, false, false);
  }

  public async uploadProviderTemplate(file: File): Promise<void> {
    const formData = new FormData();
    formData.append("providerFile", file, file.name);
    await this.makePost("njdobi/templates/provider", formData, undefined, true, false, false);
  }

  public async uploadTrainingFile(file: File): Promise<void> {
    const formData = new FormData();
    formData.append("trainingFile", file, file.name);
    await this.makePost("njdobi/training-file", formData, undefined, true, false, false);
  }
}
